(() => {
  const createArrow = (rotation) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '7');
    svg.setAttribute('height', '11');
    svg.setAttribute('viewBox', '0 0 7 11');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.transform = `rotate(${rotation}deg)`;
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M1.25 9.25L5.27307 6.03867C5.77391 5.63888 5.77473 4.87779 5.27475 4.47693L1.25 1.25');
    path.setAttribute('stroke-width', '2.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('stroke', '#3E3C39');
    svg.append(path);
    return svg;
  };
  const init = (root) => {
    root.querySelectorAll('.dynamites-product media-gallery:not([data-pdp-ready])').forEach((gallery) => {
      const slides = [...gallery.querySelectorAll('.media-gallery__track > figure')];
      if (!slides.length) return;
      gallery.dataset.pdpReady = 'true';
      const labels = gallery.closest('.product-main__media').dataset;
      const thumbs = document.createElement('div');
      thumbs.className = 'dynamites-product__thumbs';
      thumbs.setAttribute('role', 'group');
      thumbs.setAttribute('aria-label', labels.galleryLabel);
      const count = document.createElement('span');
      const buttons = [];
      const viewport = gallery.querySelector('.media-gallery__viewport');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      let selected = 0;
      let targetIndex = null;
      let lastThumbIndex = -1;
      let scrollFrame;
      const update = (index) => {
        selected = index;
        if (lastThumbIndex !== index && buttons[index] && thumbs.clientHeight) {
          const button = buttons[index];
          const top = button.offsetTop;
          const bottom = top + button.offsetHeight;
          if (top < thumbs.scrollTop) thumbs.scrollTo({ top, behavior: motion });
          else if (bottom > thumbs.scrollTop + thumbs.clientHeight) thumbs.scrollTo({ top: bottom - thumbs.clientHeight, behavior: motion });
          lastThumbIndex = index;
        }
        slides.forEach((slide, i) => slide.toggleAttribute('data-pdp-selected', i === index));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        gallery.querySelectorAll('[data-dot-index]').forEach((dot) => dot.setAttribute('aria-current', String(Number(dot.dataset.dotIndex) === index)));
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      const select = (index) => {
        index = Math.max(0, Math.min(index, slides.length - 1));
        targetIndex = index;
        update(index);
        viewport.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: motion });
      };
      slides.forEach((slide, i) => {
        const source = slide.querySelector('img');
        if (!source) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dynamites-product__thumb';
        const img = source.cloneNode();
        img.removeAttribute('style');
        img.sizes = '80px';
        img.loading = 'lazy';
        img.alt = '';
        button.setAttribute('aria-label', `${labels.galleryLabel} ${i + 1}`);
        button.append(img);
        button.addEventListener('click', () => select(i));
        buttons.push(button);
        thumbs.append(button);
      });
      const rail = document.createElement('div');
      rail.className = 'dynamites-product__thumb-rail';
      rail.append(thumbs);
      if (buttons.length > 5) {
        const controls = [-1, 1].map((direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dynamites-product__thumb-scroll';
          button.append(createArrow(direction < 0 ? -90 : 90));
          button.setAttribute('aria-label', direction < 0 ? labels.previousImage : labels.nextImage);
          button.addEventListener('click', () => {
            const step = buttons[1].offsetTop - buttons[0].offsetTop;
            thumbs.scrollBy({ top: direction * step, behavior: motion });
          });
          return button;
        });
        rail.prepend(controls[0]);
        rail.append(controls[1]);
        const syncControls = () => {
          controls[0].disabled = thumbs.scrollTop <= 1;
          controls[1].disabled = thumbs.scrollTop + thumbs.clientHeight >= thumbs.scrollHeight - 1;
        };
        thumbs.addEventListener('scroll', syncControls, { passive: true });
        requestAnimationFrame(syncControls);
      }
      gallery.prepend(rail);
      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const left = viewport.getBoundingClientRect().left;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[index].getBoundingClientRect().left - left)) index = i;
          });
          if (targetIndex !== null && index !== targetIndex) return;
          targetIndex = null;
          update(index);
        });
      }, { passive: true });
      gallery.querySelectorAll('[data-dot-index]').forEach((dot) => dot.addEventListener('click', () => select(Number(dot.dataset.dotIndex))));
      if (slides.length > 1) {
        const controls = document.createElement('div');
        controls.className = 'dynamites-product__slider-controls';
        [-1, 1].forEach((direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.append(createArrow(direction < 0 ? 180 : 0));
          button.setAttribute('aria-label', direction < 0 ? labels.previousImage : labels.nextImage);
          button.addEventListener('click', () => select((selected + direction + slides.length) % slides.length));
          controls.append(button);
        });
        gallery.querySelector('.product-media').append(controls);
      }
      let drag;
      let dragged = false;
      viewport.addEventListener('pointerdown', (event) => {
        targetIndex = null;
        dragged = false;
        drag = { x: event.clientX, y: event.clientY, left: viewport.scrollLeft, mouse: event.pointerType === 'mouse' };
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!drag) return;
        if (Math.abs(event.clientX - drag.x) > 8) dragged = true;
        if (drag.mouse && dragged) {
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
          viewport.scrollLeft = drag.left + drag.x - event.clientX;
        }
      });
      const endDrag = () => {
        const mouse = drag?.mouse;
        drag = null;
        viewport.classList.remove('is-dragging');
        if (mouse && dragged) select(selected);
      };
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('click', (event) => {
        if (dragged) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      viewport.querySelectorAll('img').forEach((img) => img.draggable = false);
      const info = document.createElement('div');
      info.className = 'dynamites-product__gallery-info';
      const caption = document.createElement('div');
      caption.className = 'dynamites-product__caption';
      const model = document.createElement('span');
      model.textContent = labels.model || '';
      caption.append(model, count);
      info.append(caption);
      if (slides.length > 1) {
        const closer = document.createElement('button');
        closer.type = 'button';
        closer.className = 'dynamites-product__closer';
        const source = slides[1].querySelector('img');
        const img = source.cloneNode();
        img.removeAttribute('style');
        img.sizes = '136px';
        img.loading = 'lazy';
        img.alt = '';
        const text = document.createElement('span');
        text.textContent = labels.closerLook;
        const detail = document.createElement('small');
        detail.textContent = source.alt.replace(/\{\{.*?\}\}/g, '').trim();
        text.append(detail);
        const arrow = document.createElement('img');
        arrow.className = 'dynamites-product__arrow';
        arrow.src = labels.arrow;
        arrow.alt = '';
        arrow.width = 18;
        arrow.height = 18;
        closer.append(img, text, arrow);
        closer.addEventListener('click', () => { select(1); slides[1].click(); });
        info.append(closer);
      }
      gallery.append(info);
      update(0);
    });
  };
  init(document);
  new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('media-gallery,.shopify-section') || node.querySelector?.('media-gallery'))))) init(document);
  }).observe(document.body, { childList: true, subtree: true });
})();
